/**
 * Shared frontend constants.
 * Extract magic numbers here for readability and consistency.
 */

// Time
export const SECONDS_IN_HOUR = 3600;
export const SECONDS_IN_DAY = 86400;
export const SECONDS_IN_WEEK = 604800;

// File upload — keep in sync with backend policy (utils/media_validation.py
// and MAX_UPLOAD_MB env). Closed beta allows images + PDF only.
export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const ALLOWED_UPLOAD_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'application/pdf',
];
export const UPLOAD_ACCEPT_ATTR = ALLOWED_UPLOAD_MIME_TYPES.join(',');

// Typing indicator
export const TYPING_TIMEOUT_MS = 2000;
export const TYPING_CLEAR_MS = 3000;

// Disappearing message duration choices (label -> seconds)
export const DISAPPEARING_DURATIONS = {
  '1h': SECONDS_IN_HOUR,
  '24h': SECONDS_IN_DAY,
  '7d': SECONDS_IN_WEEK,
};
